import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * FranceTenure Widget
 */
@Component({
  selector: 'france-tenure-widget',
  templateUrl: './france-tenure-widget.component.html'
})
export class FranceTenureWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'franceTenure', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler('franceTenure', this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('franceTenure');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('franceTenure', this.getReport());
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Add new row
   */
  addNewRow() {
    this.widgetData.tenureFranceRow.push({ sheet: "", plot: "", parcel: "" });
  }

  /**
   * Remove row
   * @param i {any} Row index
   */
  removeRow(i) {
    this.widgetData.tenureFranceRow.splice(i, 1);
  }
}
